import React from 'react';
import Link from 'next/link'
import {Grid} from "@material-ui/core";
import {stringBytes} from "../../../../stores/tools/commons";
import {css} from "@emotion/react";
import colorPalette from "../../../../styles/theme/colorPalette";

const PartnerCard = (props, isCommentCut = false) => {
  const { id, name, hospital, licentiate, recommend_common_comment } = props.data
  return (
      <div css={wrapper}>
        <Link href={{
          pathname: '/partners/[id]',
          query: {id: id},
        }}
              prefetch={false}
        >
          <a>
            <Grid container flexWrap={'nowrap'} alignItems={'start'}>
              <Grid item css={{width: '30%', maxWidth: '100px'}}>
                <div css={partnerImage}>
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img src={`${process.env.NEXT_PUBLIC_LEGACY_BUCKET_URL}/shop/dietitians/rec_${id}.jpg`} alt={name}/>
                </div>
              </Grid>
              <Grid item css={{flex: 1}}>
                {
                  hospital && <p css={affiliation}>{ hospital.name }</p>
                }
                <p css={affiliation}>{ licentiate }</p>
                <p css={nameArea}>{ name }<span>先生</span></p>
              </Grid>
            </Grid>
            {
              recommend_common_comment &&
              <div css={commentArea}>
                {
                  props && props.isCommentCut &&
                  recommend_common_comment.substring(0,37) + '…'
                  ||
                  recommend_common_comment
                }
              </div>
            }
          </a>
        </Link>
      </div>
  );
};

export default PartnerCard;

const wrapper = css`
  border: solid 1px ${colorPalette.primary};
  padding: 16px;
  height: 100%;
`

const partnerImage = css`
  position: relative;
  overflow: hidden;
  padding-top: 100%;
  width: 100%;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
`

const affiliation = css`
  margin: 0 0 0 16px;
  color: ${colorPalette.gray};
  font-size: 1.4rem;
`

const nameArea = css`
  margin: 4px 0 0 16px;
  font-size: 1.8rem;
  line-height: 1.2;
  span {
    margin-left: 0.5rem;
    font-size: 1.4rem;
  }
`

const commentArea = css`
  font-size: 1.4rem;
  margin-top: 8px;
  line-height: 1.7;
`